import type { ProviderDto } from '../providers/models';
import type { VendorDto } from '../vendors/models';
import type { ServiceDto } from '../services/models';
import type { ConfigurationState } from './configuration-state.enum';
import type { PagedRequestDto } from '../pagination/models';

export interface ServiceConfigurationDto {
  id: number;
  provider: ProviderDto;
  vendor: VendorDto;
  service: ServiceDto;
  purchaseOrderNumber: number;
  purchaseOrderLine: number;
  state?: ConfigurationState;
}

export interface ServiceConfigurationInputDto {
  id: number;
  providerId: number;
  vendorId: number;
  serviceId: number;
  purchaseOrderNumber: number;
  purchaseOrderLine: number;
  state?: ConfigurationState;
}

export interface ServiceConfigurationPagedRequestDto extends PagedRequestDto {
  providerId?: number;
  vendorId?: number;
  serviceId?: number;
  purchaseOrderNumber?: number;
  state?: ConfigurationState;
}
